import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import { useFetchPosFlag } from "../../collectPayment/context/customHook";
import { PAGE_STATE } from "../../collectPayment/context/constants";
import { initialForm } from "../../collectPayment/selectPaymentMode/components/constant";
import { reviewReceipt, validateExamChargesPaymentMode, validateSequencing } from "./utils";
import { fetchExamCharges, useGetSelectedChargesTotals, useGetUserRoledId } from "./customHooks";
import { useGetStudentDetails } from "../../collectPayment/reviewAndReceipt/utils";
import { useParams } from "react-router";
import { useGetAllBusinessArea } from "../../../businessArea/component/FirstForm/FeatureSetup/utils";


export const ExamChargesModuleContext = createContext({});

export const useGetExamChargesContext = () => {
  return useContext(ExamChargesModuleContext);
}

export const ExamChargesModuleContextProvider = ({ children, ...props }) => {

  const { psid } = useParams();

  const [currentPageState, setCurrentPageState] = useState(PAGE_STATE.SELECT_PAYMENT_MODE);
  const [currentStep, setCurrentStep] = useState(0);
  const [studentChargesList, setStudentCharges] = useState({
    loading: false,
    REGULAR_CHARGES: [],
    OTHER_CHARGES: []
  })
  const [selectedCharges, setSelectedCharges] = useState({
    REGULAR_CHARGES: [],
    OTHER_CHARGES: [],
  });
  const [selectionModel, setSelectionModel] = useState([]);
  const [state, setState] = useState('');

  //select payment mode states
  const [currentPaymentMode, setCurrentPaymentMode] = useState("default");
  const [bankDropdown, setBankDropdown] = useState([]);
  const [paymentModeForm, setPaymentModeForm] = useState(initialForm);
  const [availablePosList, setAvailablePos] = useState([])
  const [bankMasterId, setBankMasterId] = useState({});
  const [balanceAmount, setBalanceAmount] = useState();
  const [balanceMode, setBalanceMode] = useState(false);
  const [loader, setloader] = useState(false);
  const [collectPayment, setCollectPayment] = useState([]);
  const [collectVoucherList, setCollectVoucherList] = useState([]);
  const [paymentModeIdLimitList, setPaymentModeIdLimitList] = useState({
    paymentModeIdList: [],
    maxLimit: "",
  });
  const [modifyPaymentModeData, setModifyPaymentModeData] = useState({});
  const [vouchersDialogOpen, setVouchersDialogOpen] = useState(true);
  const [totalUnpaidAmount, setTotalUnpaidAmount] = useState(0)

  //hooks and customHooks
  const studentDetails1 = useGetStudentDetails({ psid });
  const allActiveBusinessArea = useGetAllBusinessArea(true);
  const roleId = useGetUserRoledId();

  const studentBasicDetails = useMemo(() => {
    const { businessArea: bu, buId, rollNumber, courseId, term, id: examOtherChargeId, examTimeCode } = selectedCharges['OTHER_CHARGES']?.[0] ?? {}
    return {
      ...(studentDetails1?.details ?? {}),
      bu,
      buId,
      rollNumber,
      courseId,
      term,
      examOtherChargeId,
      examTimeCode
    };

  }, [studentDetails1, selectedCharges]);

  useEffect(() => {
    allActiveBusinessArea?.length > 0 && fetchExamChargesData();
  }, [allActiveBusinessArea])

  const isOnlineModeEnabled = useFetchPosFlag(studentBasicDetails, setAvailablePos);

  const {
    totalBaseAmount,
    totalConcessionAmount,
    totalPayableAmount,
    totalTaxes,
    totalFinalPayable
  } = useGetSelectedChargesTotals(selectedCharges);

  const fetchExamChargesData = () => fetchExamCharges(psid, setStudentCharges, allActiveBusinessArea, setState);

  const paymentModeFormHandler = (key, value) => {
    setPaymentModeForm({ ...paymentModeForm, [key]: value });
  };

  const landingPageDataLoading =
    allActiveBusinessArea?.length === 0 ||
    studentChargesList?.loading ||
    studentDetails1?.loading;

  const amountToBePaid = totalFinalPayable;
  const selectedChargesAmount = totalFinalPayable;
  const totalCollectedAmount = [...collectPayment, ...collectVoucherList]?.reduce((acc, curr) => acc + (+curr.paidAmount), 0);

  return (
    <ExamChargesModuleContext.Provider
      value={{
        studentBasicDetails,
        studentDetails1,
        currentStep,
        setCurrentStep,
        currentPageState,
        setCurrentPageState,
        state,
        setState,

        studentChargesList,
        selectedCharges,
        selectedChargesAmount,
        setSelectedCharges,

        currentPaymentMode,
        setCurrentPaymentMode,
        bankDropdown,
        setBankDropdown,
        setPaymentModeForm,
        paymentModeForm,
        paymentModeFormHandler,
        roleId,
        bankMasterId,
        setBankMasterId,
        balanceAmount,
        setBalanceAmount,
        balanceMode,
        setBalanceMode,
        loader,
        setloader,
        collectPayment,
        setCollectPayment,
        collectVoucherList,
        setCollectVoucherList,
        paymentModeIdLimitList,
        setPaymentModeIdLimitList,
        modifyPaymentModeData,
        setModifyPaymentModeData,
        isOnlineModeEnabled,
        amountToBePaid,
        totalCollectedAmount,
        vouchersDialogOpen,
        setVouchersDialogOpen,
        totalUnpaidAmount,
        setTotalUnpaidAmount,
        availablePosList,

        fetchExamChargesData,
        landingPageDataLoading,

        selectionModel,
        setSelectionModel,
        totalBaseAmount,
        totalConcessionAmount,
        totalPayableAmount,
        totalTaxes,
        totalFinalPayable,

        //pseudo validation functions
        validatePaymentMode: validateExamChargesPaymentMode,
        validateSequencing,
        reviewReceipt,
        ...props,
      }}
    >
      {children}
    </ExamChargesModuleContext.Provider>
  )
}